import { supabase } from "../../supabaseClient"
import { loadNetPaidByBank } from "./installment"

export const saveBank = async (id = undefined, item) => {
    if (id) {
        return await supabase
            .from('Bank')
            .update({ ...item })
            .match({ id })
    } else {
        return await supabase
            .from('Bank')
            .insert([{ ...item }])
    }
}

export const loadBanks = async (companyId) => {
    let { data, error } = await supabase
        .from('Bank')
        .select('*')
        .eq("company_id", companyId)
        .is('deleted_at', null)
        .order('name', { ascending: true })
    if (!error) {
        return data
    }
    return []
}

// Carrega os bancos com o SALDO ATUAL calculado (Ajuste 06): balance é o saldo
// inicial imutável; currentBalance = balance + soma líquida das parcelas pagas
// do banco. Usar onde se exibe/usa o saldo do momento (dashboard, extrato,
// projeção). O cadastro do banco continua usando `balance` (saldo inicial).
export const loadBanksWithCurrentBalance = async (companyId) => {
    const [banks, netByBank] = await Promise.all([
        loadBanks(companyId),
        loadNetPaidByBank(companyId),
    ])
    return (banks || []).map((b) => ({
        ...b,
        currentBalance: (Number(b.balance) || 0) + (netByBank[b.id] || 0),
    }))
}

export const deleteBank = async (id, userId) => {
    return await supabase
        .from('Bank')
        .update({ deleted_at: new Date(), deleted_by: userId })
        .match({ id })
}
